export const JACKPOT_ID = "jp-ex";

export const CASINO_PROVIDER_NAME = "casino";
export const PLAY_N_GO_BRAND_NAME = "Play’n’go";
